import _toConsumableArray from "/Users/nivarazin/Desktop/Projects/wordley/fjordle/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/nivarazin/Desktop/Projects/wordley/fjordle/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/nivarazin/Desktop/Projects/wordley/fjordle/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/nivarazin/Desktop/Projects/wordley/fjordle/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/nivarazin/Desktop/Projects/wordley/fjordle/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/nivarazin/Desktop/Projects/wordley/fjordle/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { FileLoader, Loader, ShapePath } from 'three';

var FontLoader = /*#__PURE__*/function (_Loader) {
  _inherits(FontLoader, _Loader);

  function FontLoader(manager) {
    _classCallCheck(this, FontLoader);

    return _possibleConstructorReturn(this, _getPrototypeOf(FontLoader).call(this, manager));
  }

  _createClass(FontLoader, [{
    key: "load",
    value: function load(url, onLoad, onProgress, onError) {
      var scope = this;
      var loader = new FileLoader(this.manager);
      loader.setPath(this.path);
      loader.setRequestHeader(this.requestHeader);
      loader.setWithCredentials(this.withCredentials);
      loader.load(url, function (text) {
        var font = scope.parse(JSON.parse(text));
        if (onLoad) onLoad(font);
      }, onProgress, onError);
    }
  }, {
    key: "parse",
    value: function parse(json) {
      return new Font(json);
    }
  }]);

  return FontLoader;
}(Loader); //


var Font = /*#__PURE__*/function () {
  function Font(data) {
    _classCallCheck(this, Font);

    this.isFont = true;
    this.type = 'Font';
    this.data = data;
  }

  _createClass(Font, [{
    key: "generateShapes",
    value: function generateShapes(text) {
      var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
      var shapes = [];
      var paths = createPaths(text, size, this.data);

      for (var p = 0, pl = paths.length; p < pl; p++) {
        shapes.push.apply(shapes, _toConsumableArray(paths[p].toShapes()));
      }

      return shapes;
    }
  }]);

  return Font;
}();

function createPaths(text, size, data) {
  var chars = Array.from(text);
  var scale = size / data.resolution;
  var line_height = (data.boundingBox.yMax - data.boundingBox.yMin + data.underlineThickness) * scale;
  var paths = [];
  var offsetX = 0,
      offsetY = 0;

  for (var i = 0; i < chars.length; i++) {
    var char = chars[i];

    if (char === '\n') {
      offsetX = 0;
      offsetY -= line_height;
    } else {
      var ret = createPath(char, scale, offsetX, offsetY, data);
      offsetX += ret.offsetX;
      paths.push(ret.path);
    }
  }

  return paths;
}

function createPath(char, scale, offsetX, offsetY, data) {
  var glyph = data.glyphs[char] || data.glyphs['?'];

  if (!glyph) {
    console.error('THREE.Font: character "' + char + '" does not exists in font family ' + data.familyName + '.');
    return;
  }

  var path = new ShapePath();
  var x, y, cpx, cpy, cpx1, cpy1, cpx2, cpy2;

  if (glyph.o) {
    var outline = glyph._cachedOutline || (glyph._cachedOutline = glyph.o.split(' '));

    for (var i = 0, l = outline.length; i < l;) {
      var action = outline[i++];

      switch (action) {
        case 'm':
          // moveTo
          x = outline[i++] * scale + offsetX;
          y = outline[i++] * scale + offsetY;
          path.moveTo(x, y);
          break;

        case 'l':
          // lineTo
          x = outline[i++] * scale + offsetX;
          y = outline[i++] * scale + offsetY;
          path.lineTo(x, y);
          break;

        case 'q':
          // quadraticCurveTo
          cpx = outline[i++] * scale + offsetX;
          cpy = outline[i++] * scale + offsetY;
          cpx1 = outline[i++] * scale + offsetX;
          cpy1 = outline[i++] * scale + offsetY;
          path.quadraticCurveTo(cpx1, cpy1, cpx, cpy);
          break;

        case 'b':
          // bezierCurveTo
          cpx = outline[i++] * scale + offsetX;
          cpy = outline[i++] * scale + offsetY;
          cpx1 = outline[i++] * scale + offsetX;
          cpy1 = outline[i++] * scale + offsetY;
          cpx2 = outline[i++] * scale + offsetX;
          cpy2 = outline[i++] * scale + offsetY;
          path.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, cpx, cpy);
          break;
      }
    }
  }

  return {
    offsetX: glyph.ha * scale,
    path: path
  };
}

export { FontLoader, Font };